<template>
    <div class="ui card" :class="[current_pack == pack? 'raised' : '']">
        <div class="content">
            <a class="ui ribbon label" v-if="is_processing" :class="[current_pack == pack ? 'teal' : 'grey' ]">{{ pack.core_waybill_number }}</a>
            <a class="ui ribbon label" v-else :class="[current_pack == pack ? 'teal' : 'grey' ]" @click="show">{{ pack.core_waybill_number }}</a>
        </div>
        <div class="ui bottom attached buttons">
            <div class="ui basic primary disabled button" v-if="is_processing == true">拆包</div>
            <div class="ui basic primary button" v-else @click="unpacking">拆包</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pack: Object,
        current_pack: Object,
        all_packs: Array,
    },
    data: function() {
        return {
            is_processing: false,
        }
    },
    computed: {
    },
    watch: {
    },
    beforeCreate: function () {
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
        show: function() {
            var that = this;
            var number = that.pack.core_waybill_number;
            that.$bus.$emit("packer_command_center", "show", number);
        },
        unpacking: function() {
            var that = this;
            var number = that.pack.core_waybill_number;
            that.$bus.$emit("packer_command_center", "unpacking", number);
        },
    },
    components: {
    }
}
</script>
